module.exports = __webpack_public_path__ + "img/logo.2fc50617.png";